import { Injectable } from '@angular/core';

class TablePage {
  count: number;
  limit: number;
  offset: number;
  pageSize: number;
}

@Injectable()
export class RoutingDataService {
  private lastMarketList = '';
  private lastMarketListPage: TablePage;
  private lastMarketListSort: any;
  private marketOverviewEntries: any;

  private _searchValMarketTitle = '';
  private _searchValMarketNumber = '';
  private _searchValMarketMaster = '';
  private _searchValClosingMarketMaster = '';

  private _selectedStatusFilter: { value: string, label: string };
  private _selectedWeekdayFilter: { value: string, label: string };
  private _selectedBranchFilter: { value: string, label: string };

  constructor() {}

  setLastMarketList(lastMarketList: string) {
    this.lastMarketList = lastMarketList;
  }

  getLastMarketList(): string {
    return this.lastMarketList;
  }

  setLastMarketListPage(lastMarketListPage: TablePage) {
    this.lastMarketListPage = lastMarketListPage;
  }

  getLastMarketListPage(): TablePage {
    return this.lastMarketListPage;
  }

  setLastMarketListSort(sort: any) {
    this.lastMarketListSort = sort;
  }

  getLastMarketListSort(): any {
    return this.lastMarketListSort;
  }

  getMarketOverviewEntries(): any {
    return this.marketOverviewEntries;
  }

  setMarketOverviewEntries(value: any) {
    this.marketOverviewEntries = value;
  }

  get searchValMarketTitle(): string {
    return this._searchValMarketTitle;
  }

  set searchValMarketTitle(value: string) {
    this._searchValMarketTitle = value;
  }

  get searchValMarketNumber(): string {
    return this._searchValMarketNumber;
  }

  set searchValMarketNumber(value: string) {
    this._searchValMarketNumber = value;
  }

  get searchValMarketMaster(): string {
    return this._searchValMarketMaster;
  }

  set searchValMarketMaster(value: string) {
    this._searchValMarketMaster = value;
  }

  get searchValClosingMarketMaster(): string {
    return this._searchValClosingMarketMaster;
  }

  set searchValClosingMarketMaster(value: string) {
    this._searchValClosingMarketMaster = value;
  }

  get selectedStatusFilter(): { value: string; label: string } {
    return this._selectedStatusFilter;
  }

  set selectedStatusFilter(value: { value: string; label: string }) {
    this._selectedStatusFilter = value;
  }

  get selectedWeekdayFilter(): { value: string; label: string } {
    return this._selectedWeekdayFilter;
  }

  set selectedWeekdayFilter(value: { value: string; label: string }) {
    this._selectedWeekdayFilter = value;
  }


  get selectedBranchFilter(): { value: string; label: string } {
    return this._selectedBranchFilter;
  }

  set selectedBranchFilter(value: { value: string; label: string }) {
    this._selectedBranchFilter = value;
  }

  clearMarketOverviewEntries() {
    this.marketOverviewEntries = null;
  }

  clearSearchQueryValues() {
    this._searchValMarketTitle = '';
    this._searchValMarketNumber = '';
    this._searchValMarketMaster = '';
    this._searchValClosingMarketMaster = '';
  }

  clearSelectedFilters() {
    this._selectedStatusFilter = null;
    this._selectedWeekdayFilter = null;
    this._selectedBranchFilter = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/routing-data.service.ts